import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchSuiteUsers,
  clearSuiteUsers,
  fetchSuiteCounts,
} from 'src/store/actions/suites';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { setSearch } from 'src/store/actions/search';
import { fetchContacts, deleteContactById } from 'src/store/actions/contacts';
import { selectSuiteUsers } from 'src/store/selectors/suiteUsers';
import { selectPRLoader } from 'src/store/selectors/PropertyLoader';
import { ContactFormProvider } from 'src/SharedCommonContext/ContactFormContext';
import { PropertiesForContactsProvider } from 'src/pages/Contacts/ContactsContext/PropertiesForContactsContext';
import Loader from 'src/components/Loader';
import SuiteUsersTable from 'src/components/SuiteUsersTable/SuiteUsersTable';

const SuiteUsersContent = (props: any) => {
  const dispatch = useDispatch();
  const user = useSelector(selectAuthenticatedUser);
  const suiteUsersRedux = useSelector(selectSuiteUsers);
  const loader = useSelector(selectPRLoader);

  const { suite, property } = props;

  useEffect(() => {
    const initialFetch = async () => {
      dispatch(clearSuiteUsers());
      dispatch(fetchSuiteUsers(suite.id));
      dispatch(fetchContacts(user.id, user.roles[0].role.name));
    };

    if (suite && user && user.roles && user.roles.length > 0) {
      initialFetch();
    }
  }, [dispatch, suite, user]);

  const onfetchSuiteData = useCallback(() => {
    props.onFetchSuiteData();
  }, [props]);

  const onDeleteContactById = useCallback(
    async (data: any) => {
      dispatch(deleteContactById(data.id));
      dispatch(fetchSuiteCounts(suite.id, user.roles[0].role.name));
    },
    [dispatch, suite, user]
  );

  return loader ? (
    <Loader />
  ) : (
    <SuiteUsersTable
      suite={suite}
      property={property}
      contacts={suiteUsersRedux}
      onDeleteContact={onDeleteContactById}
      onfetchSuiteData={onfetchSuiteData}
      onSearch={(e: any) =>
        dispatch(setSearch({ suiteUsers: e.target.value.trim() }))
      }
    />
  );
};

const SuiteUsers = (props: any) => {
  return (
    <ContactFormProvider>
      <PropertiesForContactsProvider>
        <SuiteUsersContent {...props} />
      </PropertiesForContactsProvider>
    </ContactFormProvider>
  );
};

export default SuiteUsers;
